import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import PpcOverTimeBrandsPlus from './components/Page';

const PpcOverTimeBrandsPlusPage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">PPC Over Time Brands With Portfolios</h3>
      </Col>
    </Row>
    <Row>
      <PpcOverTimeBrandsPlus />
    </Row>
  </Container>
);

export default PpcOverTimeBrandsPlusPage;
